//ページトップアニメ
$(function () {
    var showFlag = false;
    var topBtn = $('#page-top');
    topBtn.css('bottom', '-100px');
    var showFlag = false;
    //スクロールが100に達したらボタン表示
    $(window).scroll(function () {
        if ($(this).scrollTop() > 200) {
            if (showFlag == false) {
                showFlag = true;
                topBtn.stop().animate(
                    {
                        bottom: '0',
                    },
                    500,
                );
            }
        } else {
            if (showFlag) {
                showFlag = false;
                topBtn.stop().animate(
                    {
                        bottom: '-100px',
                    },
                    500,
                );
            }
        }
    });
    //スクロールしてトップ
    topBtn.click(function () {
        $('body,html').animate(
            {
                scrollTop: 0,
            },
            500,
        );
        return false;
    });
});

//スムーズスクロール部分の記述
$(function () {
    // #で始まるアンカーをクリックした場合に処理
    $('a[href^="#"]').click(function () {
        // スクロールの速度
        var speed = 400; // ミリ秒
        // アンカーの値取得
        var href = $(this).attr('href');
        // 移動先を取得
        var target = $(href == '#' || href == '' ? 'html' : href);
        // 移動先を数値で取得
        var position = target.offset().top;
        // スムーススクロール
        $('body,html').animate(
            {
                scrollTop: position,
            },
            speed,
            'swing',
        );
        return false;
    });
});
